import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [menuActive, setMenuActive] = useState(false);

  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  return (
   <header className="header">
    <div className="logo">
      <Link to="inicio" smooth={true} duration={500}>
        <img src="/mybricksLogoR.png" alt="Logo" />
      </Link>
    </div>

      <nav className={menuActive ? 'active' : ''}>
        <div className="menu-toggle" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} />
          {/* ☰ ícono del menú hamburguesa */}
        </div>
        <ul>
          <li><Link to="inicio" smooth={true} duration={500}>Inicio</Link></li>
          <li><Link to="about" smooth={true} duration={500}>Sobre Nosotros</Link></li>
          <li><Link to="services" smooth={true} duration={500}>Servicios</Link></li>
          <li><Link to="projects" smooth={true} duration={500}>Proyectos</Link></li>
          <li><Link to="contact" smooth={true} duration={500}>Contáctanos</Link></li>
        </ul>
      </nav>
   </header>
  );
};

export default Header;
